<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec4')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec4Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Video",
    "pageDesc":"Have a branded video for your company with custom graphics and script to communicate with your audience better.",
    "mantra":"Get your branded |video content.",
    "sec1Items":{
      "1":{
        "title":"Simplify your messages",
        "desc":"Instead of writing 300 words to describe your product, offering, process of innovation or brand essence, create a video of 30 seconds. Replace words with graphics, pictures and fun illustration that doesn’t only provide a pleasure for viewers, but touches their emotions."
      },
      "2":{
        "title":"Create a buzz",
        "desc":"Capitalize on videos as the most engaging type of content and create a buzz around your brand. Evoke emotions or entertain people through visually appealing graphics that matches with your brand essence."
      },
      "3":{
        "title":"Build trust",
        "desc":"Enjoy an asset that is durable and suitable for different channels. Whether online or offline use videos to support your business goals and build trust with your audience."
      }
    },
    "sec2":"Communicate your messages seamlessly.",
    "sec2Items":{
      "1":{
        "title":"Feature explainer",
        "desc":"Have been working on a new feature launch? Or would love to intense users to try out a feature that would make them fall in love with your product? Use explainer videos to do the task."
      },
      "2":{
        "title":"Product tours",
        "desc":"Walk your users through your digital tangible product. Showcase the features and different use cases in a simple manner."
      },
      "3":{
        "title":"Tutorials",
        "desc":"Kick off your awareness campaigns with How-to videos. Bearing in mind your field and target audience, we customize videos that help you communicate the values behind your product."
      },
      "4":{
        "title":"Short movie",
        "desc":"Unleash the full powers of storytelling with short animation movies that can be utilized in different purposes like campaigns, tv ads, events ...etc."
      },
      "5":{
        "title":"Company video",
        "desc":"Whether for recruitment purposes or values explanation, we study your brand and start working according to strategy to come up with video content that truly represents you."
      }
    },
    "sec3":"Tailored for every medium.",
    "sec3Items":{
      "1":{
        "title":"Digital marketing",
        "desc":"Integrate videos in your digital campaigns on social media or other channels and rise up your conversions."
      },
      "2":{
        "title":"Company website/ app",
        "desc":"Reduce bounce rate or direct customers through your offering with videos that are tailored to grab the attention of your audience without affecting your site performance."
      },
      "3":{
        "title":"Events and presentations ",
        "desc":"Whether a webinar or a meeting with a new investor, video content could help you create the awesomeness you want."
      }
    },
    "sec4":"How we do videos?",
    "sec4Items":{
      "1":{
        "title":"Strategy driven ",
        "desc":"Videos are an integral part of your business strategy that’s why we start with the purpose behind the video, its placements and the target audience we need to address with our messages. "
      },
      "2":{
        "title":"Custom illustration  ",
        "desc":"Conveying messages requires custom graphics. That’s why we design everything in house with no outsourced materials to guarantee quality and uniqueness."
      }
    },
    "cta":"Start with your <br> video today!"
  },
  "ar": {
    "pageTitle":"الفيديو",
    "pageDesc":"احصل على فيديو يتناسب مع علامتك التجارية من خلال رسوم  ورسائل نصية مخصصة تساعدك على التواصل مع عملائك.",
    "mantra":"احصل على فيديو يتناسب |مع علامتك التجارية.",
    "sec1Items":{
      "1":{
        "title":"بسط رسائلك",
        "desc":"بدلاً من كتابة 300 كلمة لوصف منتجك أو عرضك أو عملية الابتكار أو جوهر العلامة التجارية، قم بإنشاء فيديو مدته 30 ثانية. استبدل الكلمات بالرسومات والصور والاليستريشن الممتعة التي لا توفر فقط متعة للمشاهدين، بل تلمس عواطفهم."
      },
      "2":{
        "title":"اجعل كلمتك مسموعة",
        "desc":"احصل على أقصى استفادة من مقاطع الفيديو باعتبارها أكثر أنواع المحتوى جاذبيةً واخلق ضجيجًا حول علامتك التجارية. استحضر المشاعر أو اجذب الأشخاص من خلال رسومات جذابة بصريًا تتوافق مع جوهر علامتك التجارية."
      },
      "3":{
        "title":"ابدأ في بناء الثقة",
        "desc":"استمتع من خلال الفيديو بأصل دائم ومناسب للقنوات المختلفة. سواء أونلاين أو أوفلاين، استخدم مقاطع الفيديو لدعم أهداف عملك وبناء الثقة مع جمهورك."
      }
    },
    "sec2":"وصل رسالتك بسلاسة",
    "sec2Items":{
      "1":{
        "title":"شرح المميزات",
        "desc":"هل يتم العمل على إطلاق ميزة جديدة؟ أو هل ترغب في حث المستخدمين بشدة على تجربة ميزة تجعلهم يقعون في حب منتجك؟ استخدم الفيديو من أجل شرح كل هذه المميزات."
      },
      "2":{
        "title":"جولة مع المنتج",
        "desc":"ساعد المستخدمين على تصفح المنتج رقميًا وكأنه ملموس بين يديهم. اعرض حالات الاستخدام المختلفة والمميزات بطريقة سهلة وبسيطة."
      },
      "3":{
        "title":"دروس تعليمية",
        "desc":"انطلق في حملات التوعية من خلال مقاطع فيديو إرشادية. مع الاهتمام بـ مجالك والجمهور المستهدف، نقوم بتخصيص مقاطع الفيديو التي تساعدك على توضيح القيمة وراء منتجك."
      },
      "4":{
        "title":"فيلم قصير",
        "desc":"امتلك القوى الكاملة لرواية القصة مع أفلام الرسوم المتحركة القصيرة التي يمكن استخدامها في أغراض مختلفة مثل الحملات والإعلانات التلفزيونية والفعاليات...وغيرها."
      },
      "5":{
        "title":"فيديو الشركة",
        "desc":"سواء كان لغرض التوظيف أو شرح قيمة ما تقدمه، فإننا ندرس العلامة التجارية جيدًا ونبدأ العمل وفقًا لاستراتيجية الوصول إلى محتوى فيديو يمثلك."
      }
    },
    "sec3":"مصمم لمختلف الأوساط.",
    "sec3Items":{
      "1":{
        "title":"التسويق الرقمي",
        "desc":"يمكنك دمج مقاطع الفيديو في حملاتك الرقمية على وسائل التواصل الاجتماعي أو القنوات الأخرى وزيادة معدل التحويلات."
      },
      "2":{
        "title":"موقع الشركة / التطبيق",
        "desc":"اعمل على خفض معدل الارتداد ووجه العملاء من خلال عرضك باستخدام مقاطع فيديو مخصصة لجذب انتباه جمهورك دون التأثير على أداء موقعك."
      },
      "3":{
        "title":"الفعاليات والعروض التقديمية ",
        "desc":"سواءً كانت ندوة عبر الإنترنت أو اجتماعًا مع مستثمر جديد، فقد يساعدك محتوى الفيديو على جذب الانتباه بالشكل الذي تريده."
      }
    },
    "sec4":"كيف نقوم بإنشاء الفيديو؟",
    "sec4Items":{
      "1":{
        "title":"فيديو قائم على الاستراتيجية ",
        "desc":"تعتبر مقاطع الفيديو جزءًا لا يتجزأ من استراتيجية عملك، ولهذا السبب نبدأ بالهدف من وراء الفيديو وال والجمهور المستهدف الذي نحتاج إلى معالجته مع رسائلنا."
      },
      "2":{
        "title":"اليستريشن مخصص  ",
        "desc":"نقل الرسائل يتطلب اليستريشن مخصص. لهذا السبب نقوم بتصميم كل شيء داخليًا مع عدم الاستعانة بمصادر خارجية لضمان الجودة والتفرد."
      }
    },
    "cta":"ابدأ بمقطع الفيديو <br> الخاص بك اليوم!"
  }
}
</i18n>
